<template>
  <el-popover trigger="focus" placement="top" :disabled="!tips.length">
    <span style="display: block" v-for="(tip, tipIndex) in tips" v-html="tip" :key="tipIndex"></span>
    <div slot="reference" class="taoSirProperty-content">
      <span v-for="(format, index) in formats" :key="index">
        <span v-if="format.type === 'label'"> {{ format.text }} </span>
        <el-input-digit
          v-if="format.type === 'input'"
          nullable
          v-model.number="format.text"
          :precision="Number(propertie.precision)"
          style="width: 80px"
        ></el-input-digit>
        <span v-if="format.type === 'operator'"> {{ format.text }} </span>
        <el-select v-if="format.type === 'unit'" clearable v-model="format.text" placeholder="单位" width="80px">
          <el-option v-for="unit in propertie.unitNames" :key="unit" :label="unit" :value="unit"></el-option>
          <!-- 其他单位选项 -->
        </el-select>
      </span>
    </div>
  </el-popover>
</template>

<script>
import { cloneDeep } from 'lodash';
export default {
  props: ['_value', 'propertie', 'tipRule'],
  data() {
    return {
      formats: [],
    };
  },
  computed: {
    tips() {
      return this.tipRule || [];
    },
  },
  watch: {
    formats: {
      handler(v) {
        this.$emit('change', v);
      },
      immediate: true,
      deep: true,
    },
    _value: {
      handler(v) {
        let list = [];
        if (this.propertie && this.propertie.formats) {
          list = cloneDeep(this.propertie?.formats);
          let _value = v;
          if (_value) {
            let operatorList = list.filter(format => format.type === 'operator').map(format => format.text);
            operatorList = [...new Set(operatorList)];
            let numList = [];
            let last = _value;
            if (operatorList.length) {
              const parts = _value.split(new RegExp(operatorList.join('|')));
              numList = parts.slice(0, parts.length - 1);
              last = parts[parts.length - 1];
            }
            let match = last.match(/(\d+(\.\d+)?)(.*)/);
            let unit = '';
            if (match?.length) {
              unit = match[3];
              numList.push(match[1]);
            }

            let indexNum = 0;
            list.forEach(format => {
              if (format.type === 'input') {
                format.text = isNaN(parseFloat(numList[indexNum])) ? '' : parseFloat(numList[indexNum]);
                indexNum++;
              } else if (format.type === 'unit') {
                format.text = unit;
              }
            });
          }
        }
        list.forEach(format => {
          if (format.type === 'unit') {
            const unitNames = this.propertie?.unitNames || []
            format.text = format.text && unitNames.includes(format.text) ? format.text : unitNames[0];
          }
        });
        this.formats = list;
      },
      immediate: true,
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.taoSirProperty-content {
  font-size: 12px;
  display: inline-block;
}
</style>
